(function () {
  var mq = window.matchMedia('(min-width: 990px)');
  var dimmer = document.createElement('div');
  dimmer.className = 'fm-dimmer';
  dimmer.setAttribute('aria-hidden', 'true');
  document.body.appendChild(dimmer);

  function headerBottom() {
    var h = document.querySelector('.section-header') || document.querySelector('sticky-header');
    return h ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
  }

  function sync() {
    var open = mq.matches && document.querySelector('header .mega-menu[open]');
    if (open) dimmer.style.setProperty('--fm-dimmer-top', headerBottom() + 'px');
    dimmer.classList.toggle('is-active', !!open);
  }

  document.addEventListener('toggle', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('mega-menu')) sync();
  }, true);

  dimmer.addEventListener('click', function () {
    document.querySelectorAll('header .mega-menu[open]').forEach(function (d) {
      var s = d.querySelector('summary');
      if (s) s.click(); else d.removeAttribute('open');
    });
    sync();
  });

  window.addEventListener('scroll', function () { if (dimmer.classList.contains('is-active')) sync(); }, { passive: true });
  window.addEventListener('resize', sync);
  if (mq.addEventListener) mq.addEventListener('change', sync);
})();
